<template>
  <v-container class="mt-10">
    <v-row>
      <v-col class="text-center offset-3 v-col-6">
        <v-sheet
          color="block"
          class="pa-4 rounded"
        >
          <h1 class="mb-4">
            <v-icon size="x-large">
              mdi-github
            </v-icon>
            {{ t('fetch.authorize', {name: 'GitHub'}) }}
          </h1>

          <v-alert
            v-if="signInError"
            type="error"
          >
            {{ signInError }}
          </v-alert>
          <v-progress-circular
            v-else
            :size="50"
            color="purple"
            indeterminate
          />
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import {computed, onMounted} from 'vue';
import {useI18n} from 'vue-i18n';
import {useCookies} from 'vue3-cookies';
import {useStore} from 'vuex';

const store = useStore();
const {t} = useI18n();
const {cookies} = useCookies();

const signInError = computed(() => store.state.auth.signInError);
const signedIn = computed(() => store.state.auth.signedIn);

function readAccessToken() {
  const token = cookies.get('github_access_token');
  cookies.remove('github_access_token');
  return token;
}

async function authorizeAndRedirect(accessToken) {
  await store.dispatch('auth/authorizeGithub', accessToken);
  if (signedIn.value) {
    window.location.href = '/cabinet/dashboard';
  }
}

onMounted(() => {
  const accessToken = readAccessToken();
  if (accessToken) {
    authorizeAndRedirect(accessToken);
  }
});
</script>

<script lang="ts">
export default {
  name: 'FetchGithubAccessToken',
};
</script>
